import { Modal, ModalProps } from 'antd'
import clsx from 'clsx'

import { ModalWindowProps } from './types/modal.types'

export const BaseModal = ({ className, children, ...props }: ModalWindowProps & ModalProps) => {
  return (
    <Modal
      className={clsx(className)}
      maskTransitionName=""
      transitionName=""
      {...props}
    >
      {children}
    </Modal>
  )
}
